export enum ClientSyncType {
  Legacy = 'LEGACY',
  Evifs = 'EVIFS',
}
